import { __awaiter } from "tslib";
import mainPageHandlers from './actionsHelpers';
import services from '@/services/index';
import { setTrueFieldsNamesSpot } from './actionsHelpers/limitsBids/helpers';
import { setTrueFieldsNamesPositions } from './actionsHelpers/positions/helpers';
import router from '@/router';
import BigNumber, { BigNumber as NS } from 'bignumber.js';
import _ from 'lodash';
import { i18n } from '@/main';
import * as Sentry from '@sentry/vue';
import { createItemCloseRecord, updateItemCloseRecord } from './utils/itemClose';
const LosslessJSON = require('lossless-json');
NS.config({
    EXPONENTIAL_AT: [-100, 100] // Диапазон, за пределами которого используется экспоненциальная нотация
});
var BinanceEventTypes;
(function (BinanceEventTypes) {
    BinanceEventTypes["orderUpdate"] = "ORDER_TRADE_UPDATE";
    BinanceEventTypes["accountUpdate"] = "ACCOUNT_UPDATE";
    BinanceEventTypes["accountConfigUpdate"] = "ACCOUNT_CONFIG_UPDATE";
    BinanceEventTypes["liquidation"] = "LIQUIDATION";
    BinanceEventTypes["marketPriceUpdate"] = "markPriceUpdate";
    BinanceEventTypes["aggTrade"] = "aggTrade";
    BinanceEventTypes["spotAccountAssetsUpdate"] = "outboundAccountPosition";
    BinanceEventTypes["executionReport"] = "executionReport";
})(BinanceEventTypes || (BinanceEventTypes = {}));
var SupportedAssets;
(function (SupportedAssets) {
    SupportedAssets["usdt"] = "usdt";
    SupportedAssets["bnb"] = "bnb";
    SupportedAssets["ada"] = "ada";
    SupportedAssets["xrp"] = "xrp";
    SupportedAssets["dot"] = "dot";
    SupportedAssets["sol"] = "sol";
    SupportedAssets["btc"] = "btc";
    SupportedAssets["eth"] = "eth";
})(SupportedAssets || (SupportedAssets = {}));
const namespaced = true;
const widgetsList = ['spotWidget', 'futuresWidget', 'innerTransfersWidget', 'positionsTable', 'limitsBidsTable'];
const leveragesList = {};
const convertLosslessNumber = (_, value) => value && value.isLosslessNumber ? value.value : value;
const losselessParsedJson = (data) => LosslessJSON.parse(data, convertLosslessNumber);
let wssSpot = null;
let wssFutures = null;
let socketConnectRetries = 6;
let wssMessageId = 0;
const doGracefullStop = () => {
    if (wssFutures === null && wssSpot === null)
        return;
    if (wssFutures !== null) {
        wssFutures.onclose = null;
        wssFutures.close();
        wssFutures = null;
    }
    if (wssSpot !== null) {
        wssSpot.onclose = null;
        wssSpot.close();
        wssSpot = null;
    }
};
const listenKeys = {
    spot: '',
    futures: ''
};
let listenKeysIntervalId = 0;
const listenKeysInterval = 1000 * 60 * 9;
let binanceErrorAlertId = null;
const depositBases = {};
const requestAvailableUSDTChange = () => {
    if (wssFutures !== null) {
        wssFutures.send(JSON.stringify({
            method: 'REQUEST',
            params: [
                `${listenKeys.futures}@balance`
            ],
            id: wssMessageId++
        }));
    }
};
const throttledRequestAvailableUSDTChange = _.throttle(requestAvailableUSDTChange, 500);
const throttledHandlerAggTradeWebsocketMessage = _.throttle(mainPageHandlers.handleFuturesTickerChangeMarketPrice, 500);
const debouncedAvailableBalance = _.debounce(mainPageHandlers.updateAvailableInnerTransferBalance, 3000);
const debouncedUpdateFuturesFinres = _.debounce(function (action) {
    action(true);
}, 3000);
var CoinType;
(function (CoinType) {
    CoinType["primary"] = "primary";
    CoinType["secondary"] = "secondary";
    CoinType["additional"] = "additional";
})(CoinType || (CoinType = {}));
const initialCoinWallet = {
    USDT: NS(0),
    BTC: NS(0),
    ETH: NS(0),
    BNB: NS(0),
    XRP: NS(0),
    USDC: NS(0),
    FDUSD: NS(0),
    TUSD: NS(0)
};
const initialCoinUSDRates = {
    USDT: NS(1),
    BTC: NS(1),
    ETH: NS(1),
    BNB: NS(1),
    XRP: NS(1),
    USDC: NS(1),
    FDUSD: NS(1),
    TUSD: NS(1)
};
const initialCoinWalletLowerCased = {
    usdt: NS(0),
    btc: NS(0),
    eth: NS(0),
    bnb: NS(0),
    xrp: NS(0),
    usdc: NS(0),
    fdusd: NS(0),
    tusd: NS(0)
};
const finresVal = {
    value: NS(0),
    percent: NS(0)
};
const initialCoinFinres = {
    usdt: finresVal,
    btc: finresVal,
    eth: finresVal,
    bnb: finresVal,
    xrp: finresVal,
    usdc: finresVal,
    fdusd: finresVal,
    tusd: finresVal,
    total: finresVal
};
class State {
    constructor() {
        this.courseUpdateDate = '';
        this.USDRates = initialCoinUSDRates;
        this.fixedUSDRates = initialCoinUSDRates;
        this.spotWidget = {
            types: {
                primary: [],
                secondary: [],
                additional: []
            },
            deposit: initialCoinWallet,
            finrez: initialCoinFinres,
            settings: {
                orderSpotCoins: []
            },
            loadError: false,
            isRetry: true,
            additionalCoins: [],
            coinsConvertedToUSD: []
        };
        this.futuresWidget = {
            types: {
                primary: [],
                secondary: [],
                additional: []
            },
            deposit: Object.assign(Object.assign({}, initialCoinWalletLowerCased), { total: NS(0) }),
            available: Object.assign(Object.assign({}, initialCoinWalletLowerCased), { total: NS(0) }),
            finrez: Object.assign(Object.assign({}, initialCoinFinres), { tempBlockUpdate: false }),
            loadError: false,
            isRetry: true,
            settings: {
                multiAssets: false
            },
            additionalCoins: [],
            coinsConvertedToUSD: []
        };
        this.innerTransfersWidget = {
            futures: {
                additionalValue: initialCoinWallet
            },
            spot: {
                additionalValue: initialCoinWallet
            },
            loadError: false,
            isRetry: true
        };
        this.positionsTable = {
            loadError: false,
            isRetry: true,
            items: []
        };
        this.limitsBidsTable = {
            loadError: false,
            isRetry: true,
            items: []
        };
        this.binanceConnectionFault = false;
        this.socketsIsLoaded = false;
        this.socketConnectionPermission = true;
        this.flags = {};
    }
}
const getters = {
    getFeatureFlags: (state) => state.flags,
    getSocketsLoading: (state) => state.socketsIsLoaded,
    getBinanceConnectionFault: (state) => state.binanceConnectionFault,
    getMainPageWidget: (state) => (widgetName) => state[widgetName],
    getLoadInnerTransfersDataLoadStatus: (state) => {
        const isRetry = state.futuresWidget.isRetry && state.spotWidget.isRetry;
        const loadError = state.futuresWidget.loadError && state.spotWidget.loadError;
        return !isRetry && !loadError;
    },
    getLimitsBidsTable: (state) => state.limitsBidsTable,
    getPositionsTable: (state) => state.positionsTable,
    getCourseUpdateDate: (state) => state.courseUpdateDate,
    getSocketConnectionPermission: (state) => state.socketConnectionPermission,
    getUSDRates: (state) => state.USDRates,
    getLiquidationProgress: (state) => {
        const isMaSet = state.futuresWidget.settings.multiAssets;
        const depositSource = state.futuresWidget.deposit;
        const { usdt, usdc, btc } = depositSource;
        const depo = isMaSet ? depositSource.total : usdt.plus(usdc).plus(btc);
        if (isMaSet) {
            const margin = state.positionsTable.items.reduce((acc, curr) => {
                return acc.plus(curr.result);
            }, NS(0));
            const result = margin.div(depo).times(NS(100)).times(NS(-1));
            if (result.lte(NS(0)) || result.isNaN())
                return NS(0).toString();
            if (result.gte(NS(100)))
                return NS(100).toString();
            return result.toString();
        }
        const isCorrectTicker = (name) => {
            // @ts-ignore
            return /(USDT|USDC|BTC)$/.test(name);
        };
        const margin = state.positionsTable.items.reduce((acc, curr) => {
            if (isCorrectTicker(curr.ticker))
                return acc.plus(curr.result);
            return acc;
        }, NS(0));
        if (margin.isZero())
            return NS(0).toString();
        if (depo.isZero())
            return NS(0).toString();
        const result = margin.div(depo).times(NS(100)).times(NS(-1));
        if (result.lte(NS(0)))
            return NS(0).toString();
        if (result.gte(NS(100)))
            return NS(100).toString();
        return result.toString();
    },
    getSpotDeposit: (state) => { return state.spotWidget.deposit; },
    getSpotSettings: (state) => { return state.spotWidget.settings; },
    getSpotFinres: (state) => { return state.spotWidget.finrez; },
    getSpotAvailableSecondaryCoins: (state) => { return state.spotWidget.types.secondary; },
    getSpotAdditionalCoins: (state) => { return state.spotWidget.additionalCoins.filter((el) => !el.value.isZero()); },
    getSpotCoinsConvertedToUSD: (state) => { return state.spotWidget.coinsConvertedToUSD; },
    getFuturesDeposit: (state) => { return state.futuresWidget.deposit; },
    getFuturesAvailable: (state) => { return state.futuresWidget.available; },
    getFuturesSettings: (state) => { return state.futuresWidget.settings; },
    getFuturesFinres: (state) => { return state.futuresWidget.finrez; },
    getFuturesAvailableSecondaryCoins: (state) => { return state.futuresWidget.types.secondary; },
    getFuturesAdditionalCoins: (state) => { return state.futuresWidget.additionalCoins.filter((el) => !el.value.isZero()); },
    getFuturesCoinsConvertedToUSD: (state) => { return state.futuresWidget.coinsConvertedToUSD; },
    getFixedUSDRates: (state) => { return state.fixedUSDRates; }
};
const reloadByError = ({ dispatch, commit }, { cause }) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.captureException(new Error('Main modules reload'), { extra: { cause } });
    socketConnectRetries += 1;
    commit('setSocketsLoadingValue', false);
    yield dispatch('loadSockets');
});
const actions = {
    handleSocketMessageOnMainPage(context, payload) {
        var _a, _b;
        if (payload.type === 'spot') {
            switch (payload.data.e) {
                case (BinanceEventTypes.executionReport):
                    mainPageHandlers.handleSpotOrderUpdate(context.commit, context.getters, context.dispatch, payload.data);
                    break;
                case (BinanceEventTypes.spotAccountAssetsUpdate):
                    mainPageHandlers.handleSpotAccountBalanceUpdate(context.commit, payload.data);
                    break;
                default:
            }
        }
        else {
            switch (payload.data.e) {
                case (BinanceEventTypes.orderUpdate):
                    mainPageHandlers.handleFuturesOrderUpdate(context.commit, context.getters, context.dispatch, payload.data);
                    break;
                case (BinanceEventTypes.aggTrade):
                    throttledHandlerAggTradeWebsocketMessage(context.commit, context.getters, payload.data);
                    break;
                case (BinanceEventTypes.accountUpdate):
                    mainPageHandlers.handleAccountUpdateFutures(context.commit, payload.data, context);
                    break;
                case (BinanceEventTypes.accountConfigUpdate):
                    if (((_b = (_a = payload.data) === null || _a === void 0 ? void 0 : _a.ac) === null || _b === void 0 ? void 0 : _b.s) in leveragesList) {
                        leveragesList[payload.data.ac.s] = NS(payload.data.ac.l);
                    }
                    break;
                case (BinanceEventTypes.liquidation):
                    context.dispatch('alertsBus/openAlert', {
                        title: 'Произошла ликвидация',
                        type: 'warning',
                        autoDelete: false,
                        content: 'Биржа в принудительном порядке закрыла Ваши позиции'
                    }, { root: true });
                    break;
                default:
            }
        }
    },
    handleSocketResponseFutures({ commit }, payload) {
        payload.result.forEach((result) => {
            const request = result.req.split('@')[1];
            switch (request) {
                case 'balance': {
                    const balances = result.res.balances;
                    const usdtBalance = balances.find((balance) => balance.asset === 'USDT');
                    const usdcBalance = balances.find((balance) => balance.asset === 'USDC');
                    const btcBalance = balances.find((balance) => balance.asset === 'BTC');
                    if (usdtBalance === undefined) {
                        Sentry.captureException(new Error('no USDTBalance handleSocketResponseFutures'), { extra: { payload } });
                        return;
                    }
                    const availableUSDT = NS(usdtBalance.availableBalance);
                    const availableUSDC = NS(usdcBalance.availableBalance);
                    const availableBTC = NS(btcBalance.availableBalance);
                    commit('setAvailableUsdt', availableUSDT);
                    commit('setAvailableUsdc', availableUSDC);
                    commit('setAvailableBtc', availableBTC);
                    break;
                }
                default: break;
            }
        });
    },
    loadLimitsData({ commit }) {
        return __awaiter(this, void 0, void 0, function* () {
            commit('setWidgetProperty', {
                name: 'limitsBidsTable',
                field: 'isRetry',
                data: true
            });
            commit('setWidgetProperty', {
                name: 'limitsBidsTable',
                field: 'loadError',
                data: false
            });
            const response = yield services.mainService.getBidsTableData(null);
            if (response.success) {
                commit('setWidgetProperty', {
                    name: 'limitsBidsTable',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'limitsBidsTable',
                    field: 'items',
                    data: setTrueFieldsNamesSpot(response.data)
                });
            }
            else {
                commit('setWidgetProperty', {
                    name: 'limitsBidsTable',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'limitsBidsTable',
                    field: 'loadError',
                    data: true
                });
            }
        });
    },
    loadPositionsData({ commit, dispatch }) {
        return __awaiter(this, void 0, void 0, function* () {
            commit('setWidgetProperty', {
                name: 'positionsTable',
                field: 'isRetry',
                data: true
            });
            commit('setWidgetProperty', {
                name: 'positionsTable',
                field: 'loadError',
                data: false
            });
            const response = yield services.mainService.getPositionsTableData(null);
            if (response.success) {
                response.data.forEach((item) => {
                    dispatch('subscribeOnTickerMarketPriceChange', item.symbol);
                });
                commit('setWidgetProperty', {
                    name: 'positionsTable',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'positionsTable',
                    field: 'items',
                    data: setTrueFieldsNamesPositions(response.data)
                });
            }
            else {
                commit('setWidgetProperty', {
                    name: 'positionsTable',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'positionsTable',
                    field: 'loadError',
                    data: true
                });
            }
        });
    },
    loadInnerTransfersData({ commit }, silent = false) {
        return __awaiter(this, void 0, void 0, function* () {
            // if (!silent) {
            //   commit('setWidgetProperty', {
            //     name: 'innerTransfersWidget',
            //     field: 'isRetry',
            //     data: true
            //   })
            //   commit('setWidgetProperty', {
            //     name: 'innerTransfersWidget',
            //     field: 'loadError',
            //     data: false
            //   })
            // }
            // const response = await services.mainService.getDataInnerTransfers(null)
            // if (!response.success) {
            //   commit('setWidgetProperty', {
            //     name: 'innerTransfersWidget',
            //     field: 'isRetry',
            //     data: false
            //   })
            //   commit('setWidgetProperty', {
            //     name: 'innerTransfersWidget',
            //     field: 'loadError',
            //     data: true
            //   })
            //   return
            // }
            // commit('setWidgetProperty', {
            //   name: 'innerTransfersWidget',
            //   field: 'isRetry',
            //   data: false
            // })
            // const getAdditionalValueByType = (type: 'futures' | 'spot') => Object.keys(response.data[type].available).reduce((result: {[key: string]: string}, asset) => {
            //   result[asset] = response.data[type].available[asset]
            //   return result
            // }, {})
            // commit('setWidgetProperty', {
            //   name: 'innerTransfersWidget',
            //   field: 'futures',
            //   data: {
            //     additionalValue: {
            //       ...initialCoinWallet,
            //       ...getAdditionalValueByType('futures')
            //     }
            //   }
            // })
            // commit('setWidgetProperty', {
            //   name: 'innerTransfersWidget',
            //   field: 'spot',
            //   data: {
            //     additionalValue: {
            //       ...initialCoinWallet,
            //       ...getAdditionalValueByType('spot')
            //     }
            //   }
            // })
        });
    },
    loadSpotData({ commit }, silent = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!silent) {
                commit('setWidgetProperty', {
                    name: 'spotWidget',
                    field: 'isRetry',
                    data: true
                });
                commit('setWidgetProperty', {
                    name: 'spotWidget',
                    field: 'loadError',
                    data: false
                });
            }
            const response = yield services.v2.widgets.getSpotWidgetData();
            if (!response.success) {
                commit('setWidgetProperty', {
                    name: 'spotWidget',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'spotWidget',
                    field: 'loadError',
                    data: true
                });
                return;
            }
            const wallet = response.data.payload.wallet;
            let deposit = {};
            let finResults = {
                total: {
                    value: NS(wallet.finResultsAll.value),
                    percent: NS(wallet.finResultsAll.percent)
                }
            };
            let types = {
                primary: [],
                secondary: [],
                additional: []
            };
            let prices = {};
            const coinsConvertedToUSD = [];
            const additionalCoins = [];
            Object.entries(wallet.coins).forEach(([coinName, coinData]) => {
                additionalCoins.push({
                    name: coinName,
                    value: NS(coinData.walletBalance)
                });
                deposit = Object.assign(Object.assign({}, deposit), { [coinName]: NS(coinData.walletBalance) });
                finResults = Object.assign(Object.assign({}, finResults), { [coinName.toLowerCase()]: {
                        value: NS(coinData.finResults.value),
                        percent: NS(coinData.finResults.percent),
                        isConvertedToUSD: coinData.finResults.isConvertedToUSD
                    } });
                types = Object.assign(Object.assign({}, types), { [coinData.type]: [...types[coinData.type], coinName] });
                prices = Object.assign(Object.assign({}, prices), { [coinName]: NS(coinData.priceUSD) });
                if (coinData.finResults.isConvertedToUSD)
                    coinsConvertedToUSD.push(coinName);
            });
            commit('setSpotCoinsConvertedToUSD', coinsConvertedToUSD);
            const defaultOrder = ['BTC', 'ETH', 'BNB', 'XRP', 'TUSD'];
            const order = new Set(wallet.sortedCoins.filter((el) => defaultOrder.includes(el)));
            const orderedList = [];
            order.forEach((coin) => {
                const currentCoin = additionalCoins.find((depositCoin) => depositCoin.name === coin);
                if (currentCoin)
                    orderedList.push(currentCoin);
            });
            commit('setWidgetProperty', {
                name: 'spotWidget',
                field: 'additionalCoins',
                data: orderedList
            });
            commit('setWidgetProperty', {
                name: 'spotWidget',
                field: 'types',
                data: types
            });
            commit('setWidgetProperty', {
                name: 'spotWidget',
                field: 'deposit',
                data: deposit
            });
            commit('setWidgetProperty', {
                name: 'spotWidget',
                field: 'finrez',
                data: finResults
            });
            commit('setWidgetProperty', {
                name: 'spotWidget',
                field: 'settings',
                data: { orderSpotCoins: wallet.sortedCoins }
            });
            commit('setUSDRates', prices);
            commit('setFixedUSDRates', prices);
            commit('setWidgetProperty', {
                name: 'innerTransfersWidget',
                field: 'spot',
                data: {
                    additionalValue: Object.assign(Object.assign({}, initialCoinWallet), deposit)
                }
            });
            commit('setCourseDate');
            commit('setWidgetProperty', {
                name: 'spotWidget',
                field: 'isRetry',
                data: false
            });
            commit('setSocketConnectionPermission', response.status !== 423);
        });
    },
    loadFuturesData({ commit, state }, silent = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!silent) {
                commit('setWidgetProperty', {
                    name: 'futuresWidget',
                    field: 'isRetry',
                    data: true
                });
                commit('setWidgetProperty', {
                    name: 'futuresWidget',
                    field: 'loadError',
                    data: false
                });
            }
            const response = yield services.v2.widgets.getFuturesWidgetData();
            if (!response.success) {
                commit('setWidgetProperty', {
                    name: 'futuresWidget',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'futuresWidget',
                    field: 'loadError',
                    data: true
                });
                return;
            }
            const { leverages, settings, wallet } = response.data.payload;
            localStorage.setItem('leverages', JSON.stringify(leverages));
            commit('setWidgetProperty', {
                name: 'futuresWidget',
                field: 'settings',
                data: settings
            });
            let deposit = {};
            let available = {};
            let finResults = {
                total: {
                    value: NS(wallet.finResultsAll.value),
                    percent: NS(wallet.finResultsAll.percent)
                }
            };
            let prices = {};
            let types = {
                primary: [],
                secondary: [],
                additional: []
            };
            const additionalCoins = [];
            const coinsConvertedToUSD = [];
            let transfersAvailable = {};
            Object.entries(wallet.coins).forEach(([coinName, coinData]) => {
                additionalCoins.push({
                    name: coinName,
                    value: NS(coinData.walletBalance)
                });
                prices = Object.assign(Object.assign({}, prices), { [coinName]: NS(coinData.priceUSD) });
                deposit = Object.assign(Object.assign({}, deposit), { [coinName.toLowerCase()]: NS(coinData.walletBalance) });
                available = Object.assign(Object.assign({}, available), { [coinName.toLowerCase()]: NS(coinData.availableBalance) });
                transfersAvailable = Object.assign(Object.assign({}, transfersAvailable), { [coinName]: NS(coinData.walletBalance) });
                finResults = Object.assign(Object.assign({}, finResults), { [coinName.toLowerCase()]: {
                        value: NS(coinData.finResults.value),
                        percent: NS(coinData.finResults.percent),
                        isConvertedToUSD: coinData.finResults.isConvertedToUSD
                    } });
                if (coinData.finResults.isConvertedToUSD)
                    coinsConvertedToUSD.push(coinName);
                types = Object.assign(Object.assign({}, types), { [coinData.type]: [...types[coinData.type], coinName] });
            });
            commit('setFuturesCoinsConvertedToUSD', coinsConvertedToUSD);
            const defaultOrder = ['ETH', 'BNB', 'XRP', 'FDUSD', 'TUSD'];
            const order = new Set(wallet.sortedCoins.filter((el) => defaultOrder.includes(el)));
            const orderedList = [];
            order.forEach((coin) => {
                const currentCoin = additionalCoins.find((depositCoin) => depositCoin.name === coin);
                if (currentCoin)
                    orderedList.push(currentCoin);
            });
            commit('setWidgetProperty', {
                name: 'futuresWidget',
                field: 'additionalCoins',
                data: orderedList
            });
            commit('setUSDRates', prices);
            commit('setFixedUSDRates', prices);
            commit('setCourseDate');
            // @ts-ignore
            // const isMaSet = settings.multiAssets
            // const setCurrencyDataHandler = (asset: string) => {
            //   console.log(asset)
            //   const { availableBalance, walletBalance } = wallet.coins[asset.toUpperCase()]
            //   const { value, percent } = wallet.coins[asset.toUpperCase()].finResults
            //   const baseDepo = NS(walletBalance).minus(NS(value))
            //   localStorage.setItem(`baseDeposit${asset}`, baseDepo + '')
            //   localStorage.setItem(`transfersFutures${asset}`, '0')
            //   // deposit[asset.toLowerCase()] = NS(currencyDeposit)
            //   // available[asset.toLowerCase()] = NS(availableCurrency)
            //   // finrez[asset.toLowerCase()] = {
            //   //   value: NS(finresValue),
            //   //   percent: NS(finresPercent)
            //   // }
            // }
            // if (!isMaSet) {
            //   Object.keys(finResults).forEach((coin) => {
            //     if (coin !== 'total') setCurrencyDataHandler(coin)
            //   })
            // } else {
            //   available = {
            //     ...available,
            //     total: NS(wallet.availableBalanceUSD)
            //   }
            //   deposit = {
            //     ...deposit,
            //     total: NS(wallet.walletBalanceUSD)
            //   }
            //   // depositBases.total = deposit.total
            // }
            // for (const item in finrez) {
            //   depositBases[item] = deposit[item].minus(finrez[item].value)
            // }
            // for (const [key, v] of Object.entries(response.data.leverages) as any) {
            //   leveragesList[key] = NS(v)
            // }
            // const totalFinresValue = isMaSet ? response.data.wallet.finResults.totalInUSD?.value : response.data.wallet.finResults.totalInUSDT?.value
            // const totalFinresPercent = isMaSet ? response.data.wallet.finResults.totalInUSD?.percent : response.data.wallet.finResults.totalInUSDT?.percent
            // finrez.total = {
            //   value: NS(totalFinresValue),
            //   percent: NS(totalFinresPercent)
            // }
            commit('setWidgetProperty', {
                name: 'futuresWidget',
                field: 'deposit',
                data: deposit
            });
            commit('setWidgetProperty', {
                name: 'futuresWidget',
                field: 'available',
                data: available
            });
            commit('setWidgetProperty', {
                name: 'futuresWidget',
                field: 'finrez',
                data: finResults
            });
            commit('setWidgetProperty', {
                name: 'futuresWidget',
                field: 'types',
                data: types
            });
            commit('setWidgetProperty', {
                name: 'innerTransfersWidget',
                field: 'futures',
                data: {
                    additionalValue: Object.assign(Object.assign({}, initialCoinWallet), transfersAvailable)
                }
            });
            commit('setWidgetProperty', {
                name: 'futuresWidget',
                field: 'isRetry',
                data: false
            });
            commit('tempBlockFuturesFinres', false);
        });
    },
    subscribeOnTickerMarketPriceChange(context, payload) {
        if (wssFutures !== null && wssFutures.readyState === WebSocket.OPEN) {
            wssFutures.send(JSON.stringify({
                method: 'SUBSCRIBE',
                params: [`${payload.toLowerCase()}@aggTrade`],
                id: wssMessageId++
            }));
        }
    },
    unsubscribeOnTickerMarketPriceChange(context, payload) {
        if (wssFutures !== null && wssFutures.readyState === WebSocket.OPEN) {
            wssFutures.send(JSON.stringify({
                method: 'UNSUBSCRIBE',
                params: [`${payload.toLowerCase()}@aggTrade`],
                id: wssMessageId++
            }));
        }
    },
    reloadByError: _.throttle(reloadByError, 60 * 1000),
    loadSockets({ getters, commit, dispatch }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (getters.getSocketsLoading)
                return;
            commit('setSocketsLoadingValue', true);
            commit('setBinanceError', false);
            if (binanceErrorAlertId !== null) {
                dispatch('alertsBus/removeAlert', binanceErrorAlertId, { root: true });
            }
            const isGateway = router.app.$route.name === 'gateway';
            const handleConnectionError = (type) => __awaiter(this, void 0, void 0, function* () {
                window.clearInterval(listenKeysIntervalId);
                const ping = yield services.mainService.doPing(null);
                if (ping.success) {
                    if (socketConnectRetries > 3) {
                        dispatch('loadSockets');
                    }
                    else if (socketConnectRetries > 0) {
                        if (!getters.getBinanceConnectionFault && !getters.getSocketsLoading) {
                            commit('setBinanceError', true);
                            if (getters['notifications/getTopBar'].length === 0) {
                                binanceErrorAlertId = yield dispatch('alertsBus/openAlert', {
                                    title: type === 'server' ? i18n.t('alerts.WhitelistLostBinanceConnection') : i18n.t('alerts.userLostBinanceConnection'),
                                    type: 'warning',
                                    autoDelete: false,
                                    content: '',
                                    wordBreak: true,
                                    action: type === 'server' ? undefined : {
                                        text: i18n.t('alerts.refreshThePage'),
                                        callback: () => { dispatch('loadSockets'); },
                                        position: 'bottom'
                                    }
                                }, { root: true });
                            }
                        }
                    }
                    else {
                        router.replace({ name: 'NamedErrorPage', params: { code: '503' } });
                    }
                }
                else {
                    router.replace({ name: 'NamedErrorPage', params: { code: '503' } });
                }
            });
            if (socketConnectRetries < 1) {
                commit('setSocketsLoadingValue', false);
                handleConnectionError('binance');
            }
            socketConnectRetries -= 1;
            doGracefullStop();
            // const pingBinance = async () => {
            //   const pingToBinanceResponse = await services.binance.doPingToBinance(null)
            //   if (pingToBinanceResponse.success) {
            //     setTimeout(pingBinance, 1000 * 60)
            //     commit('setBinanceError', false)
            //   } else {
            //     dispatch('loadSockets')
            //   }
            // }
            const response = yield services.mainService.getListenKeys(null);
            window.clearInterval(listenKeysIntervalId);
            listenKeysIntervalId = window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
                const resp = yield services.mainService.getListenKeys(null);
                if (!resp.success)
                    return;
                const isIdentical = listenKeys.spot === resp.data.spot && listenKeys.futures === resp.data.futures;
                if (!isIdentical) {
                    commit('setSocketsLoadingValue', false);
                    dispatch('loadSockets');
                }
                else {
                    socketConnectRetries = 5;
                }
            }), listenKeysInterval);
            if (response.success) {
                listenKeys.futures = response.data.futures;
                listenKeys.spot = response.data.spot;
                // pingBinance()
                wssSpot = new WebSocket(`wss://stream.binance.com:9443/ws/${response.data.spot}`);
                wssSpot.onopen = function () {
                    if (process.env.NODE_ENV === 'development') {
                        dispatch('alertsBus/openAlert', {
                            title: 'Сокет спота подключен к Binance',
                            type: 'info',
                            autoDelete: true,
                            content: 'Информация о всех событиях на спотовому счету будет обновляться в реальном времени'
                        }, { root: true });
                    }
                    // if (isGateway) {
                    //   if (router.app.$route.query.component === 'spotWallet') {
                    //     dispatch('loadSpotData')
                    //   }
                    // } else dispatch('loadSpotData')
                };
                wssSpot.onmessage = function (event) {
                    const parsedData = losselessParsedJson(event.data);
                    if (parsedData.e === 'listenKeyExpired') {
                        commit('setSocketsLoadingValue', false);
                        dispatch('loadSockets');
                        return;
                    }
                    dispatch('handleSocketMessageOnMainPage', {
                        type: 'spot',
                        data: parsedData
                    });
                };
                wssSpot.onerror = function () {
                    commit('setSocketsLoadingValue', false);
                    handleConnectionError('binance');
                };
                wssSpot.onclose = function () {
                    commit('setSocketsLoadingValue', false);
                    handleConnectionError('binance');
                };
                wssFutures = new WebSocket(`wss://fstream.binance.com/ws/${response.data.futures}`);
                wssFutures.onopen = function () {
                    if (process.env.NODE_ENV === 'development') {
                        dispatch('alertsBus/openAlert', {
                            title: 'Сокет фьюча подключен к Binance',
                            type: 'info',
                            autoDelete: true,
                            content: 'Информация о всех событиях на фьючерсном счету будет обновляться в реальном времени'
                        }, { root: true });
                    }
                    if (isGateway) {
                        if (router.app.$route.query.component === 'mainPagePositions') {
                            dispatch('loadPositionsData');
                        }
                        else if (router.app.$route.query.component === 'mainPageBids') {
                            dispatch('loadLimitsData');
                        }
                        else {
                            dispatch('loadPositionsData');
                            dispatch('loadLimitsData');
                            // dispatch('loadInnerTransfersData')
                            // dispatch('loadFuturesData')
                            // dispatch('loadSpotData')
                        }
                    }
                    else {
                        dispatch('loadPositionsData');
                        dispatch('loadLimitsData');
                        // dispatch('loadInnerTransfersData')
                        // dispatch('loadFuturesData')
                        // dispatch('loadSpotData')
                    }
                };
                wssFutures.onmessage = function (event) {
                    const parsedData = losselessParsedJson(event.data);
                    if (parsedData.result === null) {
                        return;
                    }
                    else if (_.isArray(parsedData.result)) {
                        dispatch('handleSocketResponseFutures', parsedData);
                    }
                    if (parsedData.e === 'listenKeyExpired') {
                        commit('setSocketsLoadingValue', false);
                        dispatch('loadSockets');
                        return;
                    }
                    dispatch('handleSocketMessageOnMainPage', {
                        type: 'futures',
                        data: parsedData
                    });
                };
                wssFutures.onerror = function () {
                    commit('setSocketsLoadingValue', false);
                    handleConnectionError('binance');
                };
                wssFutures.onclose = function () {
                    commit('setSocketsLoadingValue', false);
                    handleConnectionError('binance');
                };
            }
            else {
                commit('setWidgetProperty', {
                    name: 'limitsBidsTable',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'limitsBidsTable',
                    field: 'loadError',
                    data: true
                });
                commit('setWidgetProperty', {
                    name: 'positionsTable',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'positionsTable',
                    field: 'loadError',
                    data: true
                });
                commit('setWidgetProperty', {
                    name: 'innerTransfersWidget',
                    field: 'isRetry',
                    data: false
                });
                commit('setWidgetProperty', {
                    name: 'innerTransfersWidget',
                    field: 'loadError',
                    data: true
                });
                commit('setSocketsLoadingValue', false);
                handleConnectionError('server');
            }
        });
    },
    setPositionClose({ commit, state, dispatch, getters }, { by, ticker }) {
        const item = state.positionsTable.items.find((item) => item.ticker === ticker);
        if (item === undefined) {
            updateItemCloseRecord(dispatch, { by, id: ticker });
        }
        else {
            createItemCloseRecord(dispatch, { by, id: ticker, item });
            commit('removeItemInPositions', ticker);
        }
    },
    setOrderClose({ commit, state, dispatch }, { by, id }) {
        const item = state.limitsBidsTable.items.find((item) => item.id === id);
        if (item === undefined) {
            updateItemCloseRecord(dispatch, { by, id });
        }
        else {
            createItemCloseRecord(dispatch, { by, id, item });
            commit('removeItemInLimits', { data: id });
        }
    },
    loadFeatureFlags({ commit }) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield services.v2.widgets.getFeaturesFlags();
            const flags = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.flags) !== null && _c !== void 0 ? _c : {};
            commit('setFeaturesFlags', flags);
        });
    }
};
const mutations = {
    setFeaturesFlags(state, payload) {
        // @ts-ignore
        state.flags = payload;
    },
    setSpotCoinsConvertedToUSD(state, payload) {
        // @ts-ignore
        state.spotWidget.coinsConvertedToUSD = payload;
    },
    setFuturesCoinsConvertedToUSD(state, payload) {
        // @ts-ignore
        state.futuresWidget.coinsConvertedToUSD = payload;
    },
    setCourseDate(state) {
        function formatDate(date) {
            const day = date.getDate().toString().padStart(2, '0');
            const monthIndex = date.getMonth();
            const year = date.getFullYear();
            const months = [
                'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
                'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
            ];
            const monthName = months[monthIndex];
            return `${day} ${monthName} ${year}`;
        }
        state.courseUpdateDate = formatDate(new Date());
    },
    setAvailableUsdt(state, payload) {
        state.futuresWidget.available.usdt = payload;
        state.innerTransfersWidget.futures.additionalValue.USDT = payload;
    },
    setAvailableUsdc(state, payload) {
        state.futuresWidget.available.usdc = payload;
        state.innerTransfersWidget.futures.additionalValue.USDC = payload;
    },
    setAvailableBtc(state, payload) {
        state.futuresWidget.available.btc = payload;
        state.innerTransfersWidget.futures.additionalValue.BTC = payload;
    },
    tempBlockFuturesFinres(state, payload) {
        state.futuresWidget.finrez.tempBlockUpdate = payload;
    },
    setSocketConnectionPermission(state, paylod) {
        state.socketConnectionPermission = paylod;
    },
    setBinanceError(state, paylod) {
        state.binanceConnectionFault = paylod;
    },
    setUSDRates(state, payload) {
        state.USDRates = Object.assign(Object.assign({}, state.USDRates), payload);
    },
    setFixedUSDRates(state, payload) {
        state.fixedUSDRates = Object.assign(Object.assign({}, state.fixedUSDRates), payload);
    },
    setTotalFuturesDepositUSD(state, payload) {
        state.futuresWidget.deposit.total = payload;
    },
    setMainPageWidget(state, payload) {
        state[payload.name] = payload.data;
    },
    setWidgetProperty(state, payload) {
        state[payload.name][payload.field] = payload.data;
    },
    setAllWidgetsError(state) {
        widgetsList.forEach((widgetName) => {
            state[widgetName].isRetry = false;
            state[widgetName].loadError = true;
        });
    },
    setAllWidgetsLoading(state) {
        widgetsList.forEach((widgetName) => {
            state[widgetName].isRetry = true;
            state[widgetName].loadError = false;
        });
    },
    setMultiAssetsStatus(state, payload) {
        state.futuresWidget.settings.multiAssets = payload;
    },
    setSocketsLoadingValue(state, payload) {
        state.socketsIsLoaded = payload;
    },
    pushItemInLimits(state, payload) {
        state.limitsBidsTable.items.push(payload.data);
        if (state.futuresWidget.settings.multiAssets) {
            return debouncedAvailableBalance();
        }
        setTimeout(throttledRequestAvailableUSDTChange, 100);
    },
    updateItemInLimits(state, payload) {
        const findedIndex = state.limitsBidsTable.items.findIndex((item) => item.id === payload.id);
        if (findedIndex !== -1) {
            payload.data.forEach((item, index) => {
                state.positionsTable.items[findedIndex][payload.data[index].name] = payload.data[index].value;
            });
        }
    },
    removeItemInLimits(state, payload) {
        state.limitsBidsTable.items.splice(state.limitsBidsTable.items.findIndex((item) => item.id === payload.data), 1);
        if (state.futuresWidget.settings.multiAssets) {
            return debouncedAvailableBalance();
        }
        setTimeout(throttledRequestAvailableUSDTChange, 100);
    },
    removeAllLimitsByName(state, payload) {
        const filtred = state.limitsBidsTable.items.filter((item) => item.ticker === payload);
        if (filtred.length) {
            filtred.forEach((bid) => {
                state.limitsBidsTable.items.splice(state.limitsBidsTable.items.findIndex((item) => item.id === bid.id), 1);
            });
        }
    },
    pushItemInPosiions(state, payload) {
        state.positionsTable.items.push(payload);
        if (state.futuresWidget.settings.multiAssets) {
            return debouncedAvailableBalance();
        }
        setTimeout(throttledRequestAvailableUSDTChange, 100);
    },
    updateItemInPositions(state, payload) {
        const findedIndex = state.positionsTable.items.findIndex((item) => item.ticker === payload.ticker);
        if (findedIndex + 1) {
            payload.data.forEach((item, index) => {
                state.positionsTable.items[findedIndex][payload.data[index].name] = payload.data[index].value;
            });
        }
    },
    removeItemInPositions(state, payload) {
        const findedIndex = state.positionsTable.items.findIndex((item) => item.ticker === payload);
        if (findedIndex + 1) {
            state.positionsTable.items.splice(findedIndex, 1);
        }
        if (state.futuresWidget.settings.multiAssets) {
            return debouncedAvailableBalance();
        }
        setTimeout(throttledRequestAvailableUSDTChange, 100);
    },
    changeDepositSpot(state, payload) {
        const a = payload.asset.toLowerCase();
        if (Object.keys(SupportedAssets).includes(a)) {
            state.spotWidget.deposit[a] = payload.value;
            state.innerTransfersWidget.spot.additionalValue[payload.asset.toUpperCase()] = payload.value;
        }
    },
    updateAvailableDepositFutures(state, payload) {
        const currentValue = state.futuresWidget.available[payload.asset];
        state.futuresWidget.available[payload.asset] = currentValue.plus(payload.value);
    },
    changeDepositFutures(state, payload) {
        state.futuresWidget.additionalCoins.forEach((coin) => {
            if (coin.name === payload.asset)
                coin.value = BigNumber(payload.value);
        });
        state.innerTransfersWidget.futures.additionalValue[payload.asset.toUpperCase()] = payload.value;
        const asset = payload.asset.toLowerCase();
        state.futuresWidget.deposit[asset] = payload.value;
        if (state.futuresWidget.finrez.tempBlockUpdate) {
            state.futuresWidget.finrez.tempBlockUpdate = false;
            return;
        }
        if (!payload.ignoreUpdateFinres)
            debouncedUpdateFuturesFinres(this._actions['mainPageModules/loadFuturesData'][0]);
        // const depositBase = depositBases[asset]
        // const updateFinres = () => {
        //   if (state.futuresWidget.finrez.tempBlockUpdate) {
        //     state.futuresWidget.finrez.tempBlockUpdate = false
        //     return
        //   }
        //   // debouncedUpdateFuturesFinres(this._actions['mainPageModules/loadFuturesData'][0])
        //   // const finrez = payload.value.minus(depositBase)
        //   // let finrezPercent
        //   // if (finrez.isZero()) finrezPercent = NS(0)
        //   // else {
        //   //   const { value } = payload
        //   //   const baseDeposit = value.minus(finrez)
        //   //   finrezPercent = finrez.div(baseDeposit).times(NS(100))
        //   // }
        //   // state.futuresWidget.finrez[asset] = {
        //   //   value: finrez,
        //   //   percent: finrezPercent
        //   // }
        //   // console.log(depositBases.total.toString(), depositBases.total.isNaN(), depositBases.total.isEqualTo(0))
        //   // const totalFinresPercent = finrez.div(depositBases.total.isEqualTo(0) ? 1 : depositBases.total).times(NS(100))
        //   // state.futuresWidget.finrez.total = {
        //   //   value: depositBases.total.plus(finrez),
        //   //   percent: totalFinresPercent.isNaN() ? BigNumber(0) : totalFinresPercent
        //   // }
        // }
        // if (!payload.ignoreUpdateFinres) updateFinres()
    }
};
export default {
    namespaced,
    state: new State(),
    actions,
    getters,
    mutations
};
